var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clip-border-wrapper" }, [
    _vm.module.clipShape === "star"
      ? _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 437 416",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M218.5 3.23605L269.075 158.89L269.299 159.581H270.026H433.69L301.283 255.78L300.695 256.207L300.92 256.898L351.495 412.551L219.088 316.352L218.5 315.925L217.912 316.352L85.5054 412.551L136.08 256.898L136.305 256.207L135.717 255.78L3.31022 159.581H166.974H167.701L167.925 158.89L218.5 3.23605Z",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.module.clipShape === "triangle"
      ? _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 216 310",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M0.703666 309.5L108 1.51978L215.296 309.5H0.703666Z",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.module.clipShape === "hexagon"
      ? _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 173 199",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: { d: "M86.5 0L173 50V150L86.5 199L0 150V50L86.5 0Z" },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }